import React, {Component} from 'react';
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom';
import Storage from '../services/Storage'

export function withAuthorization(Comp, roles) {

  class Authentication extends Component {
      render() {

        const user = Storage.getItem('user');
          return (
            user && roles.includes(user.role) ?
              <Comp
                  {...this.props}/>
              : <span>You are not authorized to view this page</span>
          )
      }
  }

  function mapStateToProps (state) {
    return {}
  }

  return withRouter(connect(mapStateToProps)(Authentication));

}

export default withAuthorization;





// WEBPACK FOOTER //
// ./src/services/Authorization.js